import { Box, IconButton, Tooltip } from "@mui/material";
import { PanelBottom, PanelBottomClose, PanelLeft, PanelLeftClose, PanelRight, PanelRightClose } from "lucide-react";

interface PanelTogglesProps {
  leftOpen: boolean;
  rightOpen: boolean;
  bottomOpen: boolean;
  onLeftToggle: () => void;
  onRightToggle: () => void;
  onBottomToggle: () => void;
  leftTooltip?: {
    open: string;
    closed: string;
  };
  rightTooltip?: {
    open: string;
    closed: string;
  };
  bottomTooltip?: {
    open: string;
    closed: string;
  };
}

export default function PanelToggles({
  leftOpen,
  rightOpen,
  bottomOpen,
  onLeftToggle,
  onRightToggle,
  onBottomToggle,
  leftTooltip = { open: "Close Models", closed: "Open Models" },
  rightTooltip = { open: "Close Sites", closed: "Open Sites" },
  bottomTooltip = { open: "Close Scenarios", closed: "Open Scenarios" },
}: PanelTogglesProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={leftOpen ? leftTooltip.open : leftTooltip.closed}>
        <IconButton
          size='medium'
          onClick={onLeftToggle}
          sx={{ color: 'white', padding: '0px 4px' }}
        >
          {leftOpen ? <PanelLeftClose /> : <PanelLeft />}
        </IconButton>
      </Tooltip>

      <Tooltip title={rightOpen ? rightTooltip.open : rightTooltip.closed}>
        <IconButton
          size='medium'
          onClick={onRightToggle}
          sx={{ color: 'white', padding: '0px 4px' }}
        >
          {rightOpen ? <PanelRightClose /> : <PanelRight />}
        </IconButton>
      </Tooltip>

      <Tooltip title={bottomOpen ? bottomTooltip.open : bottomTooltip.closed}>
        <IconButton
          size='medium'
          onClick={onBottomToggle}
          sx={{ color: 'white', padding: '0px 4px' }}
        >
          {bottomOpen ? <PanelBottomClose /> : <PanelBottom />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}